import type { PermissionResponse } from 'expo-tracking-transparency'
import { PermissionStatus } from 'expo-modules-core'

export const requestTrackingPermissionsAsync: typeof import('expo-tracking-transparency').requestTrackingPermissionsAsync =
  () =>
    Promise.resolve({
      granted: false,
      expires: 'never',
      canAskAgain: true,
      status: PermissionStatus.UNDETERMINED,
    } as const satisfies PermissionResponse)
